import React, { useRef, useEffect } from "react";

const UpdateGP = ({ onSubmit, onCancel, item }) => {
    // ref
    const nameRef = useRef(null);
    const emailREf = useRef(null);
    const postCodeRef = useRef(null);
    const mobileRef = useRef(null);
    const addressRef = useRef(null);

    // Update after rendering
    useEffect(() => {
        nameRef.current.value = item.name;
        emailREf.current.value = item.email;
        addressRef.current.value = item.address;
        postCodeRef.current.value = item.post_code;
        mobileRef.current.value = item.mobile;
    });

    return (
        <form
            method="POST"
            onSubmit={event => {
                event.preventDefault();
                onSubmit({
                    name: nameRef.current.value,
                    address: addressRef.current.value,
                    email: emailREf.current.value,
                    mobile: mobileRef.current.value,
                    postCode: postCodeRef.current.value
                });
            }}
        >
            <div className="form-group">
                <label htmlFor="name-id">Name</label>
                <input type="text" className="form-control input-height" id="name-id" required ref={nameRef} aria-describedby="name-id" placeholder="enter name" />
            </div>
            <div className="form-group">
                <label htmlFor="email-id">Email</label>
                <input type="email" className="form-control input-height" id="email-id" required ref={emailREf} aria-describedby="email-id" placeholder="enter email" />
            </div>
            <div className="form-group">
                <label htmlFor="email-id">Phone Number</label>
                <input type="text" className="form-control input-height" id="phone-id" required ref={mobileRef} aria-describedby="phone-id" placeholder="enter phone number" />
            </div>
            <div className="form-group">
                <label htmlFor="post-id">Post Code</label>
                <input type="text" className="form-control input-height" id="post-id" required ref={postCodeRef} aria-describedby="post-id" placeholder="enter post code" />
            </div>

            <div className="form-group">
                <label htmlFor="address-id">Contact Address</label>
                <textarea name="address-id" id="address-id" ref={addressRef} className="form-control form-control-textarea" required rows="3" placeholder="enter contact address"></textarea>
            </div>

            <div className="text-center">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Update Changes <i className="material-icons">arrow_right_alt</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
};

export default UpdateGP;
